import {
	BEHAVIOUR_MOUSE_PARALLAX,
	FLAG_ACTIVE
} from 'app/views/home/webgl/particlesOptimised/core/ParticleCore';

import type { ParticleCore, PoolRange } from 'app/views/home/webgl/particlesOptimised/core/ParticleCore';

/**
 * MouseParallax kernel — verbatim port of ParticleMouseParallax.tick()
 * (its two private Inertias become the mpX/mpY lanes):
 *
 *   target = -(mouse.parallax.x * container.w * power.x)   // y with container.h
 *   mp += ((target - mp) / ease) * deltaTime               // Inertia ease path
 *   animatedProps.targetX += mp                            // ADDS to the target
 *
 * Reference input mapping (ParticlesWebGL._setMouse* writes, lines 478-479):
 *   mouse.parallax.x = mouseCords.x / sizes.window.w - 0.5  -> parallaxX param
 *   mouse.parallax.y = mouseCords.y / sizes.window.h - 0.5  -> parallaxY param
 * (window.w/h = viewport = HomeWebGLSizes.innerWidth/innerHeight; amplitude
 * uses container.w/h = virtualWidth/innerHeight — different metrics on x.)
 *
 * The reference skips ENTIRELY on touch (globals.lastCordsFromTouch) — the
 * caller gates the whole kernel call on that, keeping the loop branch-free.
 */
export function mouseParallaxKernel(
	core: ParticleCore,
	range: PoolRange,
	parallaxX: number,
	parallaxY: number,
	containerW: number,
	containerH: number,
	deltaTime: number
): void {
	const mask = core.behaviourMask;
	const flags = core.stateFlags;
	//Scalar parts of the per-particle targets (power applies per particle):
	const baseX = -1 * (parallaxX * containerW);
	const baseY = -1 * (parallaxY * containerH);

	for (let i = range.start; i < range.end; i++) {
		if (!(flags[i] & FLAG_ACTIVE) || !(mask[i] & BEHAVIOUR_MOUSE_PARALLAX)) {
			continue;
		}

		const targetX = baseX * core.mpPowX[i];
		const targetY = baseY * core.mpPowY[i];

		core.mpX[i] += ((targetX - core.mpX[i]) / core.mpEaseX[i]) * deltaTime;
		core.mpY[i] += ((targetY - core.mpY[i]) / core.mpEaseY[i]) * deltaTime;

		core.tx[i] += core.mpX[i];
		core.ty[i] += core.mpY[i];
	}
}
